import { ChangeEvent, memo, useCallback, useEffect, useState } from "react";
import { Security } from "../../../../proto/generated/security";
import { IconButton } from "@mui/material";
import ExtraSmallTextField from "../../../common/ExtraSmallTextField";
import { AddRounded, RemoveRounded } from "@mui/icons-material";

export type StrikeCellProps = {
    security: Security,
    disabled?: boolean,
    onChange?: (strike: number) => void,
    onStrikeIncrease: () => void,
    onStrikeDecrease: () => void
}

const StrikeCell: React.FC<StrikeCellProps> = ({security, disabled, onChange, onStrikeIncrease, onStrikeDecrease}) => {

    const [strike, setStrike] = useState<number | string>(security.strikePrice);

    const onInputStrikeChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setStrike(event.currentTarget.value);
    }, [security])

    const onInputBlur = useCallback((event: any) => {
        onChange(Number(event.target.value))
    }, [onChange])

    useEffect(() => {
        security && security.strikePrice && setStrike(security.strikePrice / (security.priceMultiplier??100));
    }, [security])

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            (e.target as any)?.blur()
        }
    }, []);

    return  <ExtraSmallTextField
                textFieldProps={{
                    id: 'strikes-textfield',
                    hiddenLabel: true,
                    className: 'rounded',
                    value: strike,
                    // inputRef: setStrikeInputRef(i),
                    onChange: onInputStrikeChange,
                    onBlur: onInputBlur,
                    type: 'number',
                    inputProps: {
                        sx: {
                            maxWidth: 40
                        }
                    },
                    disabled: disabled,
                    InputProps: {
                        startAdornment: (<IconButton
                            onClick={onStrikeDecrease}
                            disabled={disabled}
                            size={'small'}
                            sx={{ p: 0 }}><RemoveRounded
                                className="trade-panel-edit-icons" /></IconButton>),
                        endAdornment: (<IconButton
                            onClick={onStrikeIncrease}
                            disabled={disabled}
                            size={'small'}
                            sx={{ p: 0 }}><AddRounded
                                className="trade-panel-edit-icons" /></IconButton>)
                    },
                    onKeyDown: handleKeyDown
                }}
            />
}

export default memo(StrikeCell);